import React from "react";
import classNames from "classnames";
import { get, map } from "lodash";
import { Img } from "../ImgV2/Img";
import styles from "./ImageNewsGrid.module.scss";
export function ImageNewsGrid(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.topicWithRelatedPeopleWrapper
  }, map(props.news_articles, function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.article, index % 2 === 1 && styles.reverse),
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.leftBox
    }, /*#__PURE__*/React.createElement(Img, {
      className: "imageNewsGridImg",
      imgKey: get(item, "article_image", "")
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.rightBox
    }, /*#__PURE__*/React.createElement("h2", {
      className: styles.title
    }, item.article_title), /*#__PURE__*/React.createElement("p", {
      className: styles.description
    }, item.article_description), /*#__PURE__*/React.createElement("p", {
      className: styles.timestamp
    }, item.article_timestamp)));
  }));
}